import * as types from '../types/genreTypes';

const initialState = {
  items: [],
  source: '',
  loading: false,
  error: null,
};

export default function genreReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_GENRES_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_GENRES_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.items || [],
        source: action.payload.source || '',
      };
    case types.FETCH_GENRES_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
